// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card{width:40%;margin:40px 0 0 28vw!important}.panel{padding:20px!important}.labelFreq{color:rgba(0,0,0,.54);font-size:.6875rem;font-weight:400}@media screen and (max-width:768px){.card{width:100%;margin:10px!important}}", ""]);
// Exports
module.exports = exports;
